import * as React from 'react';
import * as styles from "./ConfettiElement.css";
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';

export interface IProps {
  id: string;
  height: number;
  image: string;
  left: number;
  duration: number;
  rotation?: number;
  navigatorStore?: NavigatorStore;
  onClick: () => void;
}

export interface IState {
  id: string;
  top: number;
  rotation: number;
  left: number;
  duration: number;
  transition: "linear" | "ease-out";
}

@inject('navigatorStore')
@observer
export class ConfettiElement extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      top: -props.height,
      rotation: 0,
      left: props.left,
      duration: props.duration,
      transition: "linear",
      id: props.id
    }
  }

  componentDidMount(): void {
    setTimeout(() => {
      this.setState({
        top: screen.height,
        rotation: this.props.rotation ? this.props.rotation : 0
      });
    }, 1000);
  }

  render() {
    return (
      <div
        id={this.state.id}
        className={styles.IA_confettiElement}
        style={{
          height: this.props.height,
          width: this.props.height,
          top: this.state.top,
          left: this.state.left,
          transition: `all ${this.state.duration}s ${this.state.transition}`,
          backgroundImage: `url(${this.props.image})`,
          transform: `rotate(${this.state.rotation}deg)`
        }}
        onClick={this.props.onClick != undefined ? () => {
          this.props.onClick();
          this.setState({
            id: `${this.state.id}_clicked`,
            duration: 2,
            top: window.innerHeight - this.props.height,
            left: window.innerWidth - this.props.height - (Math.random() * 50) - 10,
            rotation: Math.random() * (30 - -30) + -30,
            transition: "ease-out"
          }, () => this.forceUpdate());
        } : undefined}
      >
      </div>
    )
  }
}